import { useTranslation } from 'react-i18next';
import { Wallet } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useMyCpmWalletQuery } from '@/generated/graphql';
import { formatCents } from '@/lib/format';

export function CampaignWalletCard() {
  const { t } = useTranslation();
  const { data, loading } = useMyCpmWalletQuery({
    fetchPolicy: 'cache-and-network',
  });

  if (loading || !data?.myCpmWallet) return null;

  const wallet = data.myCpmWallet;
  if (wallet.available_cents <= 0) return null;

  return (
    <Card className="bg-card border-border p-5 sm:p-6">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-start gap-3 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center flex-shrink-0">
            <Wallet className="w-5 h-5 text-emerald-400" />
          </div>
          <div className="min-w-0">
            <p className="font-bold">{t('campaign.wallet.title')}</p>
            <div className="mt-1 flex items-center gap-3 flex-wrap">
              <span className="text-3xl font-bold">
                {formatCents(wallet.available_cents, 'BRL')}
              </span>
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-400 text-[11px] font-bold">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
                {t('campaign.wallet.statusPill')}
              </span>
            </div>
          </div>
        </div>
        <Button
          asChild
          size="lg"
          className="bg-emerald-400 hover:bg-emerald-500 text-emerald-950 font-semibold"
        >
          <Link to="/earn/wallet">{t('campaign.wallet.requestButton')}</Link>
        </Button>
      </div>
    </Card>
  );
}
